/**
 * @file Wagner identicon support.
 */
import { TransformOptions } from './types'

function areOptionsSupportedForIdenticons(options: TransformOptions): boolean {
  if (!['limit', 'thumb', ''].includes(options.crop || '')) return false
  if (options.width && !options.height && options.ar && options.ar !== 1) return false
  if (options.height && !options.width && options.ar && options.ar !== 1) return false
  if (options.width && options.height && options.width !== options.height) return false
  if (options.blur) return false
  if (options.effect) return false
  if (options.format) return false
  if (options.grayscale) return false
  if (options.metadata) return false
  if (options.quality) return false
  if (options.trim) return false
  return true
}

function canServeIdenticonDirectly(url: string, options: TransformOptions): boolean {
  // check if url is of form https://padlet.net/identicons/<number>.png
  const regex = /^https:\/\/padlet\.net\/identicons\/[0-9]+\.png$/
  return areOptionsSupportedForIdenticons(options) && regex.test(url)
}

function canServe(url: string, options: TransformOptions): boolean {
  return canServeIdenticonDirectly(url, options)
}

function processedUrl(url: string, options: TransformOptions): string {
  const dpr = options.dpr ? Number(options.dpr) : 1
  const dim = options.width || options.height
  if (!dim) {
    return url
  } else {
    const size = dim * dpr
    return url.replace(/\.png$/, `x${size}.png`)
  }
}

export { canServe, processedUrl }
